import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAssetStatus, useStartLessonProgress, useStartTrackProgress } from '../userProgressQueries';
import { useHistory } from 'quartz-routing/react-router';
import Raven from 'raven-js';
import { usePlaylistIdFromSearch } from '../../playlistContent/hooks';
import getLang from 'academy-common-lib/utils/getLang';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { getOverviewModalEnrollUrl } from '../../../utils/RoutingUtils';
import { Metrics } from '../../../Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
const WideUIButton = props => {
  const {
    isMobile,
    isNotMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    as: "span",
    display: "inline-block",
    inlineSize: isMobile ? '100%' : undefined,
    maxInlineSize: "600px",
    minInlineSize: isNotMobile ? '200px' : undefined,
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      block: true
    }, props))
  });
};
export const EnrollTrackButton = ({
  language,
  id,
  onEnroll,
  to
}) => {
  const {
    push
  } = useHistory();
  const playlistId = usePlaylistIdFromSearch();
  const {
    status
  } = useAssetStatus({
    type: 'TRACK',
    id
  });
  const [startTrackProgress, {
    startTrackProgressLoading
  }] = useStartTrackProgress({
    trackId: id,
    language: (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang(),
    playlistId
  });
  const handleEnroll = () => {
    const resolvedLanguage = (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang();
    startTrackProgress().then(() => {
      Metrics.counter('track-started').increment();
    }).catch(error => {
      Metrics.counter('track-mutation-call-error', {
        action: 'track-start-error'
      }).increment();
      Raven.captureException(error instanceof Error ? error : new Error('Start Track Error'), {
        extra: {
          originalError: error,
          trackId: id,
          language: resolvedLanguage
        }
      });
    });
    push(getOverviewModalEnrollUrl({
      to: to !== null && to !== void 0 ? to : `/tracks/${id}`,
      language,
      playlistId
    }));
    onEnroll();
  };
  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    disabled: startTrackProgressLoading,
    onClick: handleEnroll,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.overviewModal.mainAction.track.${status}`
    })
  });
};
export const EnrollLessonButton = ({
  language,
  id,
  onEnroll,
  use = 'primary',
  to
}) => {
  const {
    push
  } = useHistory();
  const playlistId = usePlaylistIdFromSearch();
  const {
    status
  } = useAssetStatus({
    type: 'LESSON',
    id
  });
  const [startLessonProgress, {
    startLessonProgressLoading
  }] = useStartLessonProgress({
    lessonId: id,
    language: (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang(),
    playlistId
  });
  const handleEnroll = () => {
    const resolvedLanguage = (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang();
    startLessonProgress().then(() => {
      Metrics.counter('lesson-started').increment();
    }).catch(error => {
      Metrics.counter('lesson-mutation-call-error', {
        action: 'lesson-start-error'
      }).increment();
      Raven.captureException(error instanceof Error ? error : new Error('Start Lesson Error'), {
        extra: {
          originalError: error,
          lessonId: id,
          language: resolvedLanguage
        }
      });
    });
    push(getOverviewModalEnrollUrl({
      to: to !== null && to !== void 0 ? to : `/lessons/${id}`,
      language,
      playlistId
    }));
    onEnroll();
  };
  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    disabled: startLessonProgressLoading,
    onClick: handleEnroll,
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.overviewModal.mainAction.lesson.${status}`
    })
  });
};